import { Pokemon } from "./Pokemon";
import "./index.css";

export const App=()=>{
  return(
    <>
<Pokemon/>
    </>
  );
}